var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({
    el: '#app',
    duration: 300,
  }),expression:"{\n    el: '#app',\n    duration: 300,\n  }"}],staticClass:"scroll-to-top",class:{ 'scroll-to-top--show': _vm.scrollTop > 400 }},[_c('button',{staticClass:"btn btn--primary p-0 scroll-to-top__btn"},[_c('span',{staticClass:"d-block rotate"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'angle-down'],"size":"lg"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }